import { BaseBlock } from "../BaseBlock";

import { CurrentSubscriptionBlock }
    from "./CurrentSubscriptionBlock";

import { NewSubscriptionBlock }
    from "./NewSubscriptionBlock";

import { ChangeSubscriptionInfoBlock }
    from "./ChangeSubscriptionInfoBlock";

import { ConfirmSubscriptionActionsBlock }
    from "./ConfirmSubscriptionActionsBlock";

import type { Screen }
    from "../../app/api/ApiClient";

import type { SubscriptionChangeActions }
    from "../../screens/components/SubscriptionChangeActions";

import type { HeaderEvents }
    from "../../screens/components/HeaderEvents";    

type ConfirmChangeScreen =
    Extract<Screen, { type: "confirmChange" }>;

export class SubscriptionTransitionBlock
    extends BaseBlock {

    private readonly screen:
        ConfirmChangeScreen;

    private readonly actions:
        SubscriptionChangeActions;

    private readonly headerEvents:
    HeaderEvents;
        
    constructor(
        screen: ConfirmChangeScreen,
        actions: SubscriptionChangeActions,
        headerEvents: HeaderEvents
    ) {

        super();

        this.screen = screen;

        this.actions = actions;

        this.headerEvents = headerEvents;

    }

    public override mount(): void {

        super.mount();

        const root =
            document.createElement("div");

        root.className =
            "subscription-transition-block";

        const blocks = [

            new CurrentSubscriptionBlock(
                this.screen
            ),

            new NewSubscriptionBlock(
                this.screen
            ),

            new ChangeSubscriptionInfoBlock(),

            new ConfirmSubscriptionActionsBlock(

                this.screen.current_subscription.subscription_id,
                
                this.screen.new_subscription.sticker_id,

                this.actions,

                this.headerEvents

            )

        ];

        for (const block of blocks) {

            block.mount();

            root.appendChild(
                block.getRoot()
            );

        }

        this.root = root;

    }

}